import { DOMUtils } from '../../../../utils/dom'

declare let window: any

export class GTM {
    /**
     * Initialize Google Tag Manager
     */
    public init(account: string): void {
        const l = 'dataLayer'
        window[l]=window[l]||[]
        window[l].push(
            {
                'event':'gtm.js',
                'gtm.start': new Date().getTime()
            }
        )

        DOMUtils.loadScript(`//www.googletagmanager.com/gtm.js?id=${account}&l=${l}`)
    }
}
